import { observer } from 'mobx-react';
import * as React from 'react';

import { HotelMapModel } from 'models';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';

import { PropertyLocation } from 'components/infosite/property-details/property-location';
import { WhatsAroundCard } from 'components/infosite/whats-around/whats-around-card';

export interface MapAccessProps {
  mapModel?: HotelMapModel;
}

@observer
export class MapAccess extends React.Component<MapAccessProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { mapModel } = this.props;

    return (
      <UitkCard>
        <UitkCardContent>
          <PropertyLocation mapModel={mapModel} />
          <WhatsAroundCard mapModel={mapModel} />
        </UitkCardContent>
      </UitkCard>
    );
  }
}
